import { OptionItemType, FillInfoItemOfForm } from '../types/type'

/**
 * 方法说明
 * @method 方法名
 * @param {参数类型} 参数名 参数说明
 * @return {返回值类型} 返回值说明
 */

/**
 * @method 深拷贝
 * @param
 * @return
 */
export const deepCopy = (data) => {
  let dataForCopy = data instanceof Array ? [] : {}
  for (let key in data) {
    dataForCopy[key] = typeof data[key] === 'object' ? deepCopy(data[key]) : data[key]
  }
  return dataForCopy
}

/**
 * @method 针对树里面的某一个属性进行改变
 * @param
 * @return
 */
export const disposeOnePropertyForTree = (data, childrenName, propertyName, propertyValue) => {
  const dataForCopy = deepCopy(data)
  const dispose = (tree, children, key, value) => {
    tree.forEach(item => {
      if (item[children] && item[children].length) {
        dispose(item[children], children, key, value)
      }
      item[key] = value
    })
  }
  dispose(dataForCopy, childrenName, propertyName, propertyValue)
  return dataForCopy
}

/**
 * @method 找到树里面的某一项
 * @param
 * @return
 */
export const findItemForTree = (data, childrenName, propertyName, propertyValue) => {
  let itemRes = {}
  const find = (tree, children, key, value) => {
    tree.some(item => {
      if (item[key] == value) {
        itemRes = item
        return true
      } else if (item[children] && item[children].length > 0) {
        find(item[children], children, key, value)
      }
    })
  }
  find(data, childrenName, propertyName, propertyValue)
  return itemRes
}

/**
 * @method 找到树里面某一个节点的所有上级，由标识组成的数组
 * @param
 * @return
 */
export const getAllFatherNodeForTree = (data, childrenName, propertyName, propertyValue) => {
  function treeFindPath (tree, func, children, path = []) {
    if (!tree) return []
    for (const item of tree) {
      // 这里按照你的需求来存放最后返回的内容吧
      path.push(item)
      if (func(item)) return path
      if (item[childrenName]) {
        const findChildren = treeFindPath(item[childrenName], func, children, path)
        if (findChildren.length) return findChildren
      }
      path.pop()
    }
    return []
  }
  let result = treeFindPath(data, item => item[propertyName] === propertyValue, childrenName)
  return result.map(item => item[propertyName])
}

/**
 * @method 处理树里面没有子节点的节点，如：删除叶子节点的children属性
 * @param
 * @return
 */
export const disposeTheNodeHaveNoChild = (data, childrenName) => {
  const dataForCopy = deepCopy(data)
  const dispose = (tree, children) => {
    tree.forEach(item => {
      if (!item[children] || !item[children].length) {
        delete item[children]
      } else {
        item[children] && dispose(item[children], children)
      }
    })
  }
  dispose(dataForCopy, childrenName)
  return dataForCopy
}

/**
 * @method 处理食堂模块的搜索选项
 * @param
 * @return
 */
export const disposeSearchParamsForCM = (searchList, searchCheckList) => {
  const checkedList = searchList.filter(item => {
    let checked = null
    searchCheckList.forEach(v => {
      if (item.key === v) checked = item
    })
    return checked
  })
  return checkedList.reduce((result, current) => {
    let { key, value } = current
    if (value !== '') {
      switch (key) {
        case 'organizationName': {
          const contentcopy = value && value.length ? value[value.length - 1] : 0
          result['orgId'] = contentcopy
          break
        }
        case 'dateInterval': {
          if (value && value.length) {
            const [startTime, endTime] = value
            result['startTime'] = startTime + ' 00:00:00'
            result['endTime'] = endTime + ' 23:59:59'
          }
          break
        }
        case 'dateIntervalForshenpiriqi': {
          if (value && value.length) {
            const [approveStartTime, approveEndTime] = value
            result['approveStartTime'] = approveStartTime + ' 00:00:00'
            result['approveEndTime'] = approveEndTime + ' 23:59:59'
          }
          break
        }
        case 'subject':
          if (value.length) result[key] = value[value.length - 1]
          break
        case 'organizationNameForAccompanyMeal':
        case 'organizationNameForTrain':
        case 'organizationNameForRetainSpecimen':
        case 'organizationNameForDisinfect':
        case 'organizationNameForPersonnel':
          const contentcopy = value && value.length ? value[value.length - 1] : 0
          result['school'] = contentcopy
          break
        default:
          result[key] = value
          break
      }
    }
    return result
  }, {})
}

/**
 * @method 处理食堂模块的表单提交
 * @param
 * @return
 */
export const disposeFillInfoToParamsForCM = (fillInfoList) => {
  return fillInfoList.reduce((result, current) => {
    const { key, value } = current
    switch (key) {
      case 'villagesAndTowns':
        break
      case 'organizationName':
        let { name, id } = current.temporaryStorageForValue
        result['orgName'] = name
        result['orgId'] = id
        break
      case 'villagesAndTownsForAddOrUpdateAccompanyMeal':
      case 'villagesAndTownsForAddOrUpdateTrain':
      case 'villagesAndTownsForAddOrUpdateRetainSpecimen':
      case 'villagesAndTownsForAddOrUpdateDisinfect':
      case 'villagesAndTownsForAddOrUpdatePersonnel':
        {
          const { name, id } = current.temporaryStorageForValue
          result['townStr'] = name
          result['town'] = id
        }
        break
      case 'organizationNameForAddOrUpdateAccompanyMeal':
      case 'organizationNameForAddOrUpdateTrain':
      case 'organizationNameForAddOrUpdateRetainSpecimen':
      case 'organizationNameForAddOrUpdateDisinfect':
      case 'organizationNameForAddOrUpdatePersonnel':
        {
          const { name, id } = current.temporaryStorageForValue
          result['schoolStr'] = name
          result['school'] = id
        }
        break
      case 'numForSystemSetting':
      case 'standardForSystemSetting':
        current.child.forEach(v => {
          result[v.key] = v.value
        })
        break
      case 'organizationNameForIncomeAndExpenses':
        {
          const { id } = current.temporaryStorageForValue
          result['school'] = id
        }
        break
      case 'targetMonthForIncomeAndExpenses':
        result['targetMonth'] = [value]
        break
      case 'targetYearForIncomeAndExpenses':
        result['year'] = value
        break
      case 'yearMonthDay':
        {
          const arr = value.split('-')
          result['year'] = arr[0]
          result['month'] = arr[1]
          result['day'] = arr[2]
        }
        break
      default:
        result[key] = value
        break
    }
    return result
  }, {})
}

/**
 * @method 获取树里面所有的叶子节点，如：所有学校（但是这样可以把不是学校的机构也查询出来）
 * @param
 * @return
 */
export const getArrChildForTree = (data, childrenName) => {
  const dataForCopy = deepCopy(data)
  const arrChildForTree = []
  const dispose = (tree, children) => {
    tree.forEach(item => {
      if (!item[children] || !item[children].length) {
        arrChildForTree.push(item)
      } else {
        item[children] && dispose(item[children], children)
      }
    })
  }
  dispose(dataForCopy, childrenName)
  return arrChildForTree
}

/**
 * @method 获取树里面符合条件的节点（只对末节点进行此处理），如：所有学校（这个可以避免上一个问题）
 * @param
 * @return
 */
export const getArrAccordWithConditionChildForTree = (data, childrenName, propertyName, propertyValue) => {
  const dataForCopy = deepCopy(data)
  const arrChildForTree = []
  const dispose = (tree, children, key, value) => {
    tree.forEach(item => {
      if (!item[children] || !item[children].length) {
        if (item[key] === propertyValue) {
          arrChildForTree.push(item)
        }
      } else {
        item[children] && dispose(item[children], children, key, value)
      }
    })
  }
  dispose(dataForCopy, childrenName, propertyName, propertyValue)
  return arrChildForTree
}

/**
 * @method 给树形降维：(这里针对子树)
 * @param
 * @return
 */
export const getAnyOneForListOnFlatteningForTree = (data, childrenName) => {
  const anyOneForListOnFlatteningForTree = []
  const flattening = (tree, children) => {
    tree.forEach(item => {
      if (item[children] && item[children].length > 0) {
        flattening(item[children], children)
      }
      anyOneForListOnFlatteningForTree.push(item)
    })
  }
  flattening(data, childrenName)
  return anyOneForListOnFlatteningForTree
}

/**
 * @method 通过身份证号获取信息
 * @param
 * @return
 */
export const getInfoByIdCard = (userIdCard, numType) => {
  if (numType == 1) {
    // 获取出生日期
    const birth = userIdCard.substring(6, 10) + '-' + userIdCard.substring(10, 12) + '-' + userIdCard.substring(12, 14)
    return birth
  }
  if (numType == 2) {
    // 获取性别
    if (parseInt(userIdCard.substr(16, 1)) % 2 == 1) {
      return '男'
    } else {
      return '女'
    }
  }
  if (numType == 3) {
    // 获取年龄
    var myDate = new Date()
    var month = myDate.getMonth() + 1
    var day = myDate.getDate()
    var age = myDate.getFullYear() - userIdCard.substring(6, 10) - 1
    if (userIdCard.substring(10, 12) < month || userIdCard.substring(10, 12) == month && userIdCard.substring(12, 14) <= day) {
      age++
    }
    return age
  }
}

// 分割线--------------

export function toFormData (params: any): FormData {
  let formData = new FormData()
  for (var key in params) {
    formData.append(key, params[key])
  }
  return formData
}

// 组织架构可以选多个：
export const disposeSearchParams = (searchList, searchCheckList) => {
  // 处理搜索条件：
  let newArr = searchList.filter(item => {
    let res
    searchCheckList.forEach(v => {
      if (item.value === v) {
        res = item
      }
    })
    return res
  })
  let searchParams = newArr.reduce((result, current, index, arr) => {
    if (current.content !== '') {
      if (current.value === 'organizationIds') {
        let array: any = current.content
        current.contentcopy = (array || []).map(item => item[item.length - 1])
        result[current.value] = current.contentcopy
      } else if (current.value === 'punchCardTime') {
        let array: any = current.content
        result['startTime'] = array[0]
        result['endTime'] = array[1]
      } else {
        result[current.value] = current.content
      }
    }
    return result
  }, {})
  return searchParams
}

// 位运算，拼：
export const bitOperation = input => {
  if (!input.length) return 0
  let res
  for (let i = 0; i < input.length; i++) {
    res |= 1 << (input[i] - 1)
  }
  return res
}

// 位运算, 拆：
export const bitOperationUnlock = q => {
  let resArr = []
  while (q) {
    let cc = q & (~q + 1)
    q ^= cc
    resArr.push(Math.log(cc) / Math.log(2) + 1)
  }
  return resArr
}

// 找到菜单的某一项：
export const findOne = (tree, title) => {
  let res
  var find = function (arr, title) {
    arr.some(item => {
      if (item.title == title) {
        res = item
        return item
      } else if (item.subs && item.subs.length > 0) {
        find(item.subs, title)
      }
    })
  }
  find(tree, title)
  return res
}

export const findOneForModule = (tree, title) => {
  let res
  var find = function (arr, title) {
    arr.some(item => {
      if (item.title == title) {
        res = item
        return item
      } else if (item.children && item.children.length > 0) {
        find(item.children, title)
      }
    })
  }
  find(tree, title)
  return res
}

// 寻找组织架构里面的某一项：
export function findOneForOrginationTree (tree, id) {
  let res
  var find = function (arr, id) {
    arr.some(item => {
      if (item.id == id) {
        res = item
        return item
      } else if (item.children && item.children.length > 0) {
        find(item.children, id)
      }
    })
  }
  find(tree, id)
  return res
}

// 寻找组织架构里面的某一项：根据名称
export function findOneForOrginationTreeByName (tree, name) {
  let res
  var find = function (arr, name) {
    arr.some(item => {
      if (item.name == name) {
        res = item
        return item
      } else if (item.children && item.children.length > 0) {
        find(item.children, name)
      }
    })
  }
  find(tree, name)
  return res
}

// 获取所有父节点，id组成的数组：
export const getAllFatherNodeForIdList = (id, tree) => {
  function treeFindPath (tree, func, path = []) {
    if (!tree) return []
    for (const data of tree) {
      // 这里按照你的需求来存放最后返回的内容吧
      path.push(data)
      if (func(data)) return path
      if (data.children) {
        const findChildren = treeFindPath(data.children, func, path)
        if (findChildren.length) return findChildren
      }
      path.pop()
    }
    return []
  }
  let result = treeFindPath(tree, data => data.id === id)
  return result.map(item => item.id)
}

// 获取后缀名称：
export const getSuffix = (fileName: string) => {
  let index = fileName.lastIndexOf('.')
  let suffix = fileName.substr(index)
  return suffix
}

// 组织结构只能选一个：
export const disposeSearchParamsOrganizationIdsOnlyOne = (
  searchList,
  searchCheckList
) => {
  let newArr = searchList.filter(item => {
    let res
    searchCheckList.forEach(v => {
      if (item.value === v) {
        res = item
      }
    })
    return res
  })
  let searchParams = newArr.reduce((result, current, index, arr) => {
    if (current.content !== '') {
      if (current.value === 'organizationIds') {
        let contentcopy =
          current.content && current.content.length
            ? current.content[current.content.length - 1]
            : 0
        current.contentcopy = contentcopy
        result[current.value] = current.contentcopy
      } else {
        result[current.value] = current.content
      }
    }
    return result
  }, {})
  return searchParams
}

// 组织结构只能选一个：
export const disposeSearchParamsOrganizationIdsOnlyOneForSchooleId = (
  searchList,
  searchCheckList
) => {
  let newArr = searchList.filter(item => {
    let res
    searchCheckList.forEach(v => {
      if (item.value === v) {
        res = item
      }
    })
    return res
  })
  let searchParams = newArr.reduce((result, current, index, arr) => {
    if (current.content !== '') {
      if (current.value === 'organizationIds') {
        let contentcopy =
          current.content && current.content.length
            ? current.content[current.content.length - 1]
            : 0
        current.contentcopy = contentcopy
        result['schoolIds'] = [current.contentcopy]
      } else {
        result[current.value] = current.content
      }
    }
    return result
  }, {})
  return searchParams
}

// 学校可以选多个：搜索条件,方案一：通过组织结构选择，配合当前用户下面的学校列表：
export const disposeSearchParamsForSchool = (
  searchList,
  searchCheckList,
  organizationSchool,
  cb
) => {
  // 处理搜索条件：
  let newArr = searchList.filter(item => {
    let res
    searchCheckList.forEach(v => {
      if (item.value === v) {
        res = item
      }
    })
    return res
  })
  let searchParams = newArr.reduce((result, current, index, arr) => {
    if (current.value === 'schoolIds') {
      if (!current.content || !current.content.length) {
        cb && cb()
        result[current.value] = organizationSchool.map(v => v.id)
      } else {
        let array: any = current.content
        current.contentcopy = (array || []).map(item => item[item.length - 1])
        result[current.value] = current.contentcopy
      }
    } else {
      if (current.content !== '') {
        result[current.value] = current.content
      }
    }
    return result
  }, {})
  return searchParams
}

export const disposeSearchParamsForSchoolWayTwo = (
  searchList,
  searchCheckList,
  organizationSchool
) => {
  // 处理搜索条件：
  let newArr = searchList.filter(item => {
    let res
    searchCheckList.forEach(v => {
      if (item.value === v) {
        res = item
      }
    })
    return res
  })
  let searchParams = newArr.reduce((result, current, index, arr) => {
    if (current.value === 'schoolIds') {
      if (!current.contentReal) {
        result[current.value] = organizationSchool.map(v => v.id)
      } else {
        result[current.value] = current.contentReal
      }
    } else {
      if (current.content !== '') {
        result[current.value] = current.content
      }
    }
    return result
  }, {})
  return searchParams
}

// 找到学校的所有上级：组成id列表：
export const getAllFatherNodeForSchool = (treeData, id) => {
  let _that: any = this
  function treeFindPath (tree, func, path = []) {
    if (!tree) return []
    for (const data of tree) {
      // 这里按照你的需求来存放最后返回的内容吧
      path.push(data)
      if (func(data)) return path
      if (data.children) {
        const findChildren = treeFindPath(data.children, func, path)
        if (findChildren.length) return findChildren
      }
      path.pop()
    }
    return []
  }
  let result = treeFindPath(treeData, data => data.id === id)
  return result.map(item => item.id)
}

export const getNameTextInOptions = (
  options: OptionItemType[],
  value: number | string
): string => {
  let res = options.filter(item => item.value == value)
  return res.length && res[0].name ? res[0].name : '- -'
}

export const getValueInOptions = (
  options: OptionItemType[],
  name: string
): number | string | boolean => {
  let res = options.filter(item => item.name == name)
  return res.length ? res[0].value : ''
}

export const getNameTextInOptionsForObj = (
  options: OptionItemType[],
  value: number | string
) => {
  let res = options.filter(item => item.value == value)
  return res.length ? res[0] : {}
}

// 招生：学生信息列表：
// 学生列表的查询：
export const disposeSearchParamsForRsGetStudentList = (
  searchList,
  searchCheckList
) => {
  // 处理搜索条件：
  let newArr = searchList.filter(item => {
    let res
    searchCheckList.forEach(v => {
      if (item.value === v) {
        res = item
      }
    })
    return res
  })
  let searchParams = newArr.reduce((result, current, index, arr) => {
    if (current.content !== '') {
      if (current.value === 'stuStage') {
        if (current.content === 'all') {
          result[current.value] = ''
        } else {
          result[current.value] = current.content
        }
      } else {
        result[current.value] = current.content
      }
    }
    return result
  }, {})
  return searchParams
}

// 招生，报名列表的查询：：
export const disposeSearchParamsForSignUp = (searchList, searchCheckList) => {
  // 处理搜索条件：
  let newArr = searchList.filter(item => {
    let res
    searchCheckList.forEach(v => {
      if (item.value === v) {
        res = item
      }
    })
    return res
  })
  let searchParams = newArr.reduce((result, current, index, arr) => {
    if (current.content !== '') {
      if (current.value === 'schoolId') {
        if (current.content === 'all') {
          result[current.value] = ''
        } else {
          result[current.value] = current.content
        }
      } else {
        result[current.value] = current.content
      }
    }
    return result
  }, {})
  return searchParams
}

/**
 * @param 输入项列表，有特殊项的需特殊判断，这里暂时是公用的
 */
export const assemblyParamsCommon = (
  fillInfoList: FillInfoItemOfForm[]
) => {
  return fillInfoList.reduce((result, current, index, arr) => {
    let key = current.key
    result[key] = current.value
    return result
  }, {})
}

// 组织结构只能选一个：这个是专门针对资助模块：
export const disposeSearchParamsForSM = (searchList, searchCheckList) => {
  let newArr = searchList.filter(item => {
    let res
    searchCheckList.forEach(v => {
      if (item.value === v) {
        res = item
      }
    })
    return res
  })
  let searchParams = newArr.reduce((result, current, index, arr) => {
    let { content, value } = current
    if (content !== '') {
      switch (value) {
        case 'school': {
          let contentcopy =
            content && content.length ? content[content.length - 1] : 0
          result['organizationId'] = contentcopy
          break
        }
        case 'schoolId': {
          let contentcopy =
            content && content.length ? content[content.length - 1] : 0
          result['schoolId'] = contentcopy
          break
        }
        default:
          result[value] = content
      }
    }
    return result
  }, {})
  return searchParams
}
